import { FormTabGuard } from 'components/form-tab-guard';

import { SidePanel } from './components/SidePanel';
import { ProductModificationDynamicForm } from './ProductModificationForm.connect';

interface ProductModificationFormProps {
  tabId: string;
}

export function ProductModificationForm({ tabId }: ProductModificationFormProps) {
  return (
    <FormTabGuard formId={tabId}>
      <ProductModificationDynamicForm
        formId={tabId}
        hideOpenInBatchWorkspaceButton
        hideCloneButton
        hideResetButton
        hidePrivateMode
        isProductValidated
        SidePanel={<SidePanel tabId={tabId} />}
      />
    </FormTabGuard>
  );
}

ProductModificationForm.displayName = 'ProductModificationForm';
